// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';

class VenueCommon extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      data:[],
    }
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsCardDataIfNeeded,
        fetchStatsTableDataIfNeeded
      }
    } = this.props;
    // this.getVenueList();
    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getVenueList() {
    const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy/`;
    const options = {...defaultOptions};

    fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => this.setState({data:data.result}))
     .catch(error => error)
  }

  render() {
    const {
      scoreCard,
      statsTable
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded
      }
    } = this.props;

    var header = ['Name','City','Area','Start Time','End Time','Games']
    var columns = ['name','city','address','start_time','end_time','games']

    const StyledContainer = styled.div`
        width: 100%;
        `

    return(
      <div>
        <div className='row'>
          <div style={{float: 'right',padding:'1%'}}>
              <Link to={`./allocation`}>
              <FlatButton
                backgroundColor="#c6ff00"
                label="Add Allocation"
              />
              </Link>
          </div>

          <div style={{float: 'right',padding:'1%'}}>
              <Link to={`./crud/addVenue`}>
              <FlatButton
                backgroundColor="#c6ff00"
                label="Add Venue"
              />
              </Link>
          </div>

          <div style={{float: 'right',padding:'1%'}}>
              <Link to={`./crud/addLocation`}>
              <FlatButton
                backgroundColor="#c6ff00"
                label="Add New Location"
              />
              </Link>
          </div>

          {/*<div style={{float: 'right',padding:'1%'}}>
                        <Link to={`./crud/addCourt`}>
                        <FlatButton
                          backgroundColor="#c6ff00"
                          label="Add Court"
                        />
                        </Link>
                    </div>*/}

          <div style={{float: 'right',padding:'1%'}}>
              <Link to={`./crud/editCourtPricing`}>
              <FlatButton
                backgroundColor="#ec407f"
                label="Edit Pricing"
              />
              </Link>
          </div>

          <div style={{float: 'right',padding:'1%'}}>
              <Link to={`./crud/createFixture`}>
              <FlatButton
                backgroundColor="#ec407f"
                label="Create Batch"
              />
              </Link>
          </div>

          <div style={{float: 'right',padding:'1%'}}>
              <Link to={`./crud/addBuddy`}>
              <FlatButton
                backgroundColor="#ec407f"
                label="Add Buddy"
              />
              </Link>
          </div>
        </div> 
        {/* <div className="row">
                   <StatsTable bigTable={true} name="venue_list" displayName="Venue List" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                 </div> */} 
        <div className="row">
          <StatsTable bigTable={true} name="court_list" displayName="Court List" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div> 
        <div className="row">
          <StatsTable bigTable={true} name="buddy_list" displayName="Buddy List" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} name="batch_list" displayName="Batches List" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
          
      </div>
    );
  }
}

export default VenueCommon;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/venueCommon/VenueCommon.js